import { API_URLS } from "@constants";
import type { IBracketStore, } from "@store/types";
import type { Store, } from "@store/useStore";
import type { ImmerStateCreator, StoreGetter, StoreSetter, } from "@types";
import { fetchApiResponseHandler } from "@utils";
import { wagmiConfig as config, } from "@wagmiconfig";
import { produce, } from "immer";
import { type GetAccountReturnType, getAccount, watchAccount, } from "wagmi/actions";
import type { IWalletRefIdSubSlice, WalletRefIdGetResult, } from "./types";



export const createWalletRefIdSlice: ImmerStateCreator<IBracketStore, IWalletRefIdSubSlice> = ( set: StoreSetter, get: StoreGetter, ) => {


	const fetch = async () => {

		const {
			isLoading,
			isLoaded,
		} = get().referrals.walletRefId;

		if(isLoaded || isLoading)
			return;

		if(_watcher) _watcher();
		_watcher = watchAccount(config, { onChange: _onAccountChange, });	

		set(produce<Store>(state => {
			state.referrals.walletRefId.isLoading = true;
			state.referrals.walletRefId.isError = false;
			state.referrals.walletRefId.error = null;
		}));

		try {

			const data = await fetchApiResponseHandler<WalletRefIdGetResult>({
				url: `${API_URLS.BARS}/wallet/ref_id?address=${get().wallet.address}`,
				options: {
					method: "GET",
				},
				signal: new AbortController().signal,
				onAbort: () => {
					const { address:wagAddress, } = getAccount(config);
					const { address:storeAddress, } = get().wallet; 
					console.log("wallet ref_id request aborted");
					console.log("Wag", wagAddress);
					console.log("Store", storeAddress);
				},
			});

			set(produce<Store>(state => {
				state.referrals.walletRefId.data = data;
				state.referrals.walletRefId.isLoading = false;
				state.referrals.walletRefId.isLoaded = true;
			}))	;

		}
		catch (error) {
		
			set(produce<Store>(state => {
				state.referrals.walletReferrals.isLoading = false;
				state.referrals.walletReferrals.isError = true;
				state.referrals.walletReferrals.error = error instanceof Error ? error : new Error("An unknown error occurred");
			}));

		}

	}


	const refetch = () => {
		set(produce<Store>(state => {
			state.referrals.walletRefId.isLoaded = false;
		}));
		fetch();
	};


	const update = (updater: (oldData: WalletRefIdGetResult | null) => WalletRefIdGetResult) => {
		set(produce<Store>(state => {
			state.referrals.walletRefId.data = updater(state.referrals.walletRefId.data);
		}));
	};


	const setData = (data: WalletRefIdGetResult) => { 	
		set(produce<Store>(state => {
			state.referrals.walletRefId.data = data;
		}));
	};
	

	const setError = (error: Error) => {
		set(produce<Store>(state => {
			state.referrals.walletRefId.isError = true;
			state.referrals.walletRefId.error = error;
		}));
	};


	const _onAccountChange = (C: GetAccountReturnType, P:Partial<GetAccountReturnType>) => {
		if(C.address && C.isConnected) {
			if(C.address !== P.address) {
				refetch();
				return;
			}
		}
	}


	let _watcher: ReturnType<typeof watchAccount> | null = null;


	return {
		data: null,
		isLoading: false,
		isLoaded: false,
		isError: false,
		error: null,
		fetch,
		refetch,
		update,
		setData,
		setError,
	}

};
